let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Qr0d")).then(() => parcelRequire('672sa'));